import Hero from "@/assets/img/aura-scan/hero_section_full.webp"
import Overview from "@/assets/img/aura-scan/overview.webp"
import Signature from "@/assets/img/aura-scan/signature.webp"
import Sensitivity from "@/assets/img/aura-scan/sensitivity_profile_hero_image.webp"
import Superpowers from "@/assets/img/aura-scan/superpowers.webp"
import Growth from "@/assets/img/aura-scan/growth.webp"
import Channels from "@/assets/img/aura-scan/channels.webp"
import Ritual from "@/assets/img/aura-scan/ritual.webp"
import Wrapping from "@/assets/img/aura-scan/wrapping.webp"
import ColorPrimary from "@/assets/img/aura-scan/primary_aura_color_person_icon.webp"
import ColorSecondary from "@/assets/img/aura-scan/secondary_aura_color_person_icon.webp"
import AdvisorsLayout from "@/assets/img/aura-scan/advisor_cards_layout.webp"

import type { ArchetypeId } from "../types"

export interface AuraSectionArt {
  hero: string
  overview: string
  signature: string
  sensitivity: string
  superpowers: string
  growth: string
  channels: string
  ritual: string
  wrapping: string
  colorPrimary: string
  colorSecondary: string
  advisors: string
}

const moonwell: AuraSectionArt = {
  hero: Hero,
  overview: Overview,
  signature: Signature,
  sensitivity: Sensitivity,
  superpowers: Superpowers,
  growth: Growth,
  channels: Channels,
  ritual: Ritual,
  wrapping: Wrapping,
  colorPrimary: ColorPrimary,
  colorSecondary: ColorSecondary,
  advisors: AdvisorsLayout,
}

/** Unique frames exist for Moonwell; other archetypes reuse it until art ships. */
export const AURA_SECTION_ART: Record<ArchetypeId, AuraSectionArt> = {
  "wildfire-beacon": moonwell,
  rootbinder: moonwell,
  "skyline-voice": moonwell,
  moonwell,
  "prism-hearth": moonwell,
  "quiet-compass": moonwell,
  nightbloom: moonwell,
  "deep-current": moonwell,
  northlight: moonwell,
  "ember-weaver": moonwell,
  stormrider: moonwell,
  "tidal-guardian": moonwell,
}

export function artFor(id: ArchetypeId): AuraSectionArt {
  return AURA_SECTION_ART[id]
}
